// extracted by mini-css-extract-plugin
module.exports = {"justOnboarded":"SectionNewArtists_justOnboarded___vIzz","title":"SectionNewArtists_title__Ay5wR","divider":"SectionNewArtists_divider__QQ5_9"};